import { Tab as MuiTab } from '@mui/material';
import { Icon } from '@components/common/generic-icon';

export const Tab = (props) => {
  const { title, icon, value } = props;
  return <MuiTab label={title || ''} value={value} icon={<Icon name={icon} />} />;
};
